import { isMentorIdentity } from "@/lib/utils/system-roles";

export type RecordAccountStatus = "active" | "deactivated" | "in_training";

export function recordAccountStatus(user: {
  deactivated?: boolean;
  has_onboarded?: boolean | null;
  systemRoles?: string[];
}): RecordAccountStatus {
  if (user.deactivated) return "deactivated";
  if (isMentorIdentity(user.systemRoles) && user.has_onboarded === false) {
    return "in_training";
  }
  return "active";
}

export function inTrainingOptionDisabled(user: {
  has_onboarded?: boolean | null;
}): boolean {
  return user.has_onboarded !== false;
}

export function statusChangeConfirm(params: {
  to: RecordAccountStatus;
  hasOnboarded: boolean;
  isMentor: boolean;
}): {
  title: string;
  description: string;
  confirmText: string;
  destructive: boolean;
} {
  if (params.to === "deactivated") {
    return {
      title: "Deactivate user",
      description: "All active mentorships will be deactivated.",
      confirmText: "Deactivate",
      destructive: true,
    };
  }

  if (params.to === "active" && params.isMentor && !params.hasOnboarded) {
    return {
      title: "Make this mentor active?",
      description:
        "They will be able to get teens. In Training cannot be selected again.",
      confirmText: "Make active",
      destructive: false,
    };
  }

  if (params.to === "in_training") {
    return {
      title: "Reactivate user",
      description:
        "This mentor will be able to use the platform again. They will not receive teens until they are Active.",
      confirmText: "Reactivate",
      destructive: false,
    };
  }

  return {
    title: "Reactivate user",
    description: "This user will be able to use the platform again.",
    confirmText: "Reactivate",
    destructive: false,
  };
}
